import React from 'react';
import { Clock, Check } from 'lucide-react';
import { services } from '../data/mockData';
import '../styles/ServicesSection.css';

const ServicesSection = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <div className="section-label">Premium Care Services</div>
          <h2 className="section-title">Signature Medical Services</h2>
          <p className="section-description">
            Personalized cardiovascular care designed around your unique needs
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-header">
                <h3 className="service-title">{service.title}</h3>
                <div className="service-duration">
                  <Clock size={16} />
                  <span>{service.duration}</span>
                </div>
              </div>
              
              <p className="service-description">{service.description}</p>
              
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="service-feature">
                    <Check size={18} className="feature-check" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button className="service-cta">Learn More</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
